module.exports = __webpack_public_path__ + "img/砂仁.93484184.jpg";